module.exports = __webpack_public_path__ + "static/media/logo_madera.1ca06f01.png";